/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import TextEditor from '../../components/TextEditor';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import Select from "react-select";
import { message } from 'antd';
import { fetchAllUsers } from "../../services/userService";
import { createNews } from "../../services/newsService";

const AddNews = () => {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [authorName, setAuthorName] = useState("");
  const [newsCategory, setNewsCategory] = useState("");
  
  const [status, setStatus] = useState("");
  const [description, setDescription] = useState("");
  const [redirectUrl, setRedirectUrl] = useState("");
  const [thumbnailImage, setThumbnailImage] = useState(null);
  const [bannerImage, setBannerImage] = useState(null);

  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedAuthor, setSelectedAuthor] = useState(null);
  const [authors, setAuthors] = useState([]);

  useEffect(() => {
    const fetchAuthors = async () => {
      try {
        const users = await fetchAllUsers();
        const mapped = users.map(user => ({
          userid: user.user_id,
          username: user.user_name,
          user_email: user.user_email
        }));
        setAuthors(mapped);
      } catch (err) {
        console.error("Failed to fetch authors:", err);
      }
    };
    fetchAuthors();
  }, []);

  const filteredAuthors = authors.filter(author =>
    author.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
    author.user_email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const blog = [
    { value: "health", label: "Health Care" },
    { value: "child", label: "Child" },
    { value: "safety", label: "Safety" },
  ];

  const category = [
    { value: "healthcare", label: "Health Care" },
    { value: "corona", label: "Corona Virus" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title || !authorName || !newsCategory ||  !status || !description) {
      return message.warning("Please fill all required fields.");
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("author_name", authorName);
    formData.append("category", newsCategory);
    formData.append("status", status);
    formData.append("description", description);
    formData.append("redirectURL", redirectUrl);

    if (thumbnailImage) formData.append("thumbnail", thumbnailImage);
    if (bannerImage) formData.append("banner", bannerImage);

    try {
      await createNews(formData);
      message.success("News created successfully!");
      navigate("/list-news");
    } catch (error) {
      console.error("Error creating news:", error);
      message.error(error.message || "Something went wrong while creating news.");
    }
  };

  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar id='menu-item11' id1='menu-items11' activeClassName='add-blog' />
        <div className="page-wrapper">
          <div className="content">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="#">News</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <FeatherIcon icon="chevron-right" />
                    </li>
                    <li className="breadcrumb-item active">Add News</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form onSubmit={handleSubmit} encType="multipart/form-data">
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>News Details</h4>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>News Title <span className="login-danger">*</span></label>
                            <input className="form-control" type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>Redirect URL</label>
                            <input className="form-control" type="text" placeholder="https://example.com" value={redirectUrl} onChange={(e) => setRedirectUrl(e.target.value)} />
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>Author <span className="login-danger">*</span></label>
                            <div className="dropdown">
                              <div className="form-control d-flex align-items-center justify-content-between"
                                style={{ cursor: "pointer", padding: "0.375rem 0.75rem" }}
                                onClick={() => setIsOpen(!isOpen)}
                              >
                                {selectedAuthor ? (
                                  <span>{selectedAuthor.username} - {selectedAuthor.user_email}</span>
                                ) : (
                                  <span className="text-muted">Select an author</span>
                                )}
                                <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'}`}></i>
                              </div>

                              {isOpen && (
                                <div className="dropdown-menu show w-100" style={{ maxHeight: "300px", overflowY: "auto", border: "1px solid #dee2e6" }}>
                                  <div className="px-2 py-1 sticky-top bg-white">
                                    <input type="text" className="form-control form-control-sm mb-2" placeholder="Search author..."
                                      value={searchTerm}
                                      onChange={(e) => setSearchTerm(e.target.value)}
                                      autoFocus
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                  </div>
                                  {filteredAuthors.length > 0 ? (
                                    filteredAuthors.map((author) => (
                                      <button key={author.userid} type="button"
                                        className={`dropdown-item ${selectedAuthor?.userid === author.userid ? 'active' : ''}`}
                                        onClick={() => {
                                          setSelectedAuthor(author);
                                          setAuthorName(author.userid);
                                          setIsOpen(false);
                                          setSearchTerm("");
                                        }}
                                      >
                                        {author.username} - {author.user_email}
                                      </button>
                                    ))
                                  ) : (
                                    <div className="dropdown-item text-muted">No matching author found</div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>Category <span className="login-danger">*</span></label>
                            <Select options={blog} onChange={(e) => setNewsCategory(e.value)} placeholder="Select Category" />
                          </div>
                        </div>

                        

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group select-gender">
                            <label className="gen-label">Status <span className="login-danger">*</span></label>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input type="radio" name="status" value="1" onChange={(e) => setStatus(e.target.value)} className="form-check-input" /> Active
                              </label>
                            </div>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input type="radio" name="status" value="0" onChange={(e) => setStatus(e.target.value)} className="form-check-input" /> Inactive
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="form-group summer-mail">
                            <TextEditor value={description} onChange={setDescription} />
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6 ">
                          <div className="form-group local-forms">
                            
                            <div className="d-flex flex-column align-items-start">
                              <label htmlFor="thumbnail" className="upload mb-2">Thumbnail Image<span className="login-danger">*</span></label>
                              <input type="file" accept="image/*" id="thumbnail"
                                onChange={(e) => setThumbnailImage(e.target.files[0])}
                                className="form-control"
                                required />
                              {thumbnailImage && <small className="text-muted mt-1">{thumbnailImage.name}</small>}
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            
                            <div className="d-flex flex-column align-items-start">
                              <label htmlFor="banner" className="upload mb-2">Banner Image<span className="login-danger">*</span></label>
                              <input type="file" accept="image/*" id="banner"
                                onChange={(e) => setBannerImage(e.target.files[0])}
                                className="form-control"
                                required />
                              {bannerImage && <small className="text-muted mt-1">{bannerImage.name}</small>}
                            </div>
                          </div>
                        </div>


                        <div className="col-12">
                          <div className="doctor-submit text-end">
                            <button type="submit" className="btn btn-primary submit-form me-2">Publish News</button>
                            <Link to="/blogs" className="btn btn-primary cancel-form">Cancel</Link>
                          </div>
                        </div>

                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="sidebar-overlay" data-reff="" />
    </>
  );
};

export default AddNews;
